import { Input } from '../input'

export default {
  name: 'KPaginationJumper',
  inject: ['context'],
  data() {
    return {
      currentVal: '',
    }
  },
  computed: {
    totalPage() {
      return this.context.totalPage
    },
    disabled() {
      return this.context.disabled
    },
    small() {
      return this.context.small
    },
  },
  methods: {
    handleChange(e) {
      if (!this.currentVal) {
        return
      }

      // 输入的为非数字时
      if (!(/^\d*$/.test(this.currentVal))) return

      // enter时触发改变
      if (e.keyCode && e.keyCode !== 13) {
        return
      }
      if (+this.currentVal < 1) {
        this.context.current = 1
      } else if (+this.currentVal > this.totalPage) {
        this.context.current = this.totalPage
      } else {
        this.context.current = +this.currentVal
      }
      this.currentVal = ''
    },
  },
  render() {
    return (
      <div class="km-pagination__jumper">
        前往
        <Input
          class="km-pagination__jumper-input"
          size={this.small ? 'small' : null}
          disabled={this.disabled}
          hideButton={true}
          vModel={this.currentVal}
          onBlur={this.handleChange}
          onKeyup={this.handleChange}
        >
        </Input>
        页
      </div>
    )
  },
}
